import BaseGetters from '@/store/base/getters'

export default BaseGetters({
  getDownloadables: ({module}) => module.filter(schedule => schedule.is_generated || schedule.is_error)
})
